"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const i0 = require("@angular/core");
class OrganisationSsoService {
    constructor(dataService) {
        this.dataService = dataService;
    }
    getOrganisationSsoStatus() {
        return this.dataService.get("organisationSso");
    }
    setOrganisationSsoStatus(isEnabled) {
        return this.dataService.post("organisationSso/save-sso-status/" + isEnabled, {});
    }
    getOrganisationUsers() {
        return this.dataService.get("organisationSso/organisation-users");
    }
}
exports.OrganisationSsoService = OrganisationSsoService;
OrganisationSsoService.ɵfac = function OrganisationSsoService_Factory(t) { return new (t || OrganisationSsoService)(i0.ɵɵinject("dataService")); };
OrganisationSsoService.ɵprov = i0.ɵɵdefineInjectable({ token: OrganisationSsoService, factory: OrganisationSsoService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(OrganisationSsoService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: core_1.Inject,
                args: ["dataService"]
            }] }]; }, null); })();
